// CSS
import './InformationalPopover.css';
// React hooks
import { createPortal } from 'react-dom';
// Media assets
import ChevronIcon from '../../../assets/StandardIcons/ArrowIcons/chevron.png';



// ====================
// InformationalPopover – a basic informational modal.
// ====================
function InformationalPopover({
    titleText,                  // String   – the title
    bodyText,                   // String   – the popover body text
    primaryButtonText,          // String   – primary button title
    primaryButtonCallback,      // ()       – primary button callback function
    secondaryButtonText,        // String   - secondary button title
    secondaryButtonCallback,    // ()       – seconrdary button callback function
}){
    
    // JSX Component – render through a React Portal attached to the top-level HTML DOM
    return createPortal(
        // Backdrop
        <div className='InformationalPopover-backdrop'>

            {/* InformationalPopover */}
            <div className='InformationalPopover'>
                
                {/* Title */}
                <div className='InformationalPopover-title'>{titleText}</div>
                
                {/* Body */}
                <div className='InformationalPopover-body'>{bodyText}</div>
                
                {/* Buttons group */}
                <div className='InformationalPopover-buttons-group'>
                    
                    {/* Primary button */}
                    { (secondaryButtonText && secondaryButtonCallback) && <div className='InformationalPopover-buttons-group-secondary-button' onClick={() => secondaryButtonCallback()}>{secondaryButtonText}</div>}
                    
                    {/* -––– (for spacing) –––– */}
                    <div></div>

                    {/* Secondary button */}
                    <div className='InformationalPopover-buttons-group-primary-button' onClick={() => primaryButtonCallback()}>{primaryButtonText} <img src={ChevronIcon} className='InformationalPopover-chevron-icon'/></div>
                
                </div>
            </div>
        </div>,
        // Top-level HTML document object
        document.body
    );
}


// Export statement
export default InformationalPopover;